export default __webpack_public_path__ + "static/media/hindustani.3efb62f3.png";